import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalService } from '../global/global.service';

@Injectable({
  providedIn: 'root',
})
export class ValueShareService {
  constructor(private http: HttpClient, private globalService: GlobalService) {}

  getValueShareList(cuc: string, idFondo: number, fechaInicio: string, fechaFin: string) {
    return this.http.get(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/consultas/private/valorcuota/listar/${cuc}/${idFondo}/${fechaInicio}/${fechaFin}`).pipe();
  }

  getFonds(cuc: string) {
    return this.http.get(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/consultas/private/valorCuota/listarFondos/${cuc}`).pipe()

    //return this.http.get("http://localhost:8080/api/fondos-consultas-service/listarFondosVC?cuc=44708459&tipoDocumento=DNI&numeroDocumento=00030982").pipe()
  }

  getFondsDebito(cuc: string) {                    
    return this.http.get(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/cliente/private/listarFondosDebito/${cuc}`).pipe()
  }

  getFondsExcel(cuc: string, idFondo: number, fechaInicio: string, fechaFin: string) {
    return this.http.get(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/consultas/private/valorcuota/generarExcel/${cuc}/${idFondo}/${fechaInicio}/${fechaFin}`)
  }

  getNotificacions(cuc: string) {                    
    return this.http.get(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/consultas/private/notificaciones/existeNotificacion/${cuc}`).pipe()
  }

  getNotificacionsDescargar(cuc: string) {
    return this.http.get(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/consultas/private/notificaciones/descargaArchivos/${cuc}`).pipe()
  }
}
